module.exports = __webpack_public_path__ + "img/bg_row_v3.b6502c9a.svg";